import styled from "styled-components";

export default styled.div`
  position: absolute;
  border: 1px solid #eb5648;

  .square {
    position: absolute;
    width: 12px;

    height: 12px;
    background: white;
    border: 1px solid #eb5648;
    border-radius: 1px;
  }

  .resizable-handler {
    position: absolute;
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 1;

    &.tl,
    &.t,
    &.tr {
      top: -32px;
    }

    &.tl,
    &.l,
    &.bl {
      left: -32px;
    }

    &.bl,
    &.b,
    &.br {
      bottom: -32px;
    }

    &.br,
    &.r,
    &.tr {
      right: -32px;
    }

    &.l,
    &.r {
      height: 20px;
      margin-top: -10px;
    }

    &.t {
      top: -8px;
      width: 16px;
      height: 16px;
    }

    &.b {
      width: 20px;
    }
  }

  .rotate {
    position: absolute;
    left: 50%;
    top: -41px;
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .t,
  .tl,
  .tr {
    top: -7px;
  }

  .b,
  .bl,
  .br {
    bottom: -7px;
  }

  .r,
  .tr,
  .br {
    right: -7px;
  }

  .tl,
  .l,
  .bl {
    left: -7px;
  }

  .l,
  .r {
    top: 50%;
    margin-top: -7px;
  }

  .t,
  .b {
    left: 50%;
    transform: translateX(-50%);
  }

  @media only screen and (max-height: 500px) {
    .square {
      width: 12px;
      height: 12px;
      border: 0.0014925373134328358rem solid #eb5648;
      border-radius: 0.0014925373134328358rem;
    }

    .resizable-handler {
      width: 32px;
      height: 32px;

      &.tl,
      &.t,
      &.tr {
        top: -24px;
      }

      &.tl,
      &.l,
      &.bl {
        left: -24px;
      }

      &.bl,
      &.b,
      &.br {
        bottom: -24px;
      }

      &.br,
      &.r,
      &.tr {
        right: -24px;
      }

      &.t {
        top: -8px;
      }
    }

    .rotate {
      top: -41px;
      margin-left: -8px;
    }

    .t,
    .tl,
    .tr {
      top: -7px;
    }

    .b,
    .bl,
    .br {
      bottom: -7px;
    }

    .r,
    .tr,
    .br {
      right: -7px;
    }

    .tl,
    .l,
    .bl {
      left: -7px;
    }

    .l,
    .r {
      top: 50%;
    }

    .t,
    .b {
      left: 50%;
    }
  }
`;
